import React, { useContext, useEffect } from 'react'
import ArticleFormat from './ArticleFormat'

import { useTweetContext } from '../context/tweetContext'
import Loader from './Loader';


const Articles = () => {


  const context = useTweetContext();

  const loading = context.isLoading;

  console.log(context.tweets)

  let mapper;
  if(context.tweets){
  mapper = context.tweets.map(elm=><ArticleFormat key={elm.id} payload={elm}/>)
  }else{
    mapper = "Something Went Wrong"
  }
  
  return (
    <div className="articles">
      
       {loading ? <div className="d-flex j-center" style={{marginTop:"12px"}}><Loader/></div> : mapper}

        </div>
  )
}

export default Articles

